export default {
  "Source saved. Existing content is updating in the background.": "Kilden er gemt. Eksisterende indhold opdateres i baggrunden.",
  "Source saved, but the existing content update could not be queued.": "Kilden er gemt, men opdateringen af eksisterende indhold kunne ikke sættes i kø.",
  "Source saved; some existing content could not be updated.": "Kilden er gemt; noget eksisterende indhold kunne ikke opdateres.",
  "Existing content update completed.": "Opdateringen af eksisterende indhold er fuldført.",
  "Content batches processed": "Behandlede indholdsbatches",
  "Update existing content": "Opdater eksisterende indhold",
  "Choose how to update existing content": "Vælg, hvordan eksisterende indhold skal opdateres",
  "Only these changes": "Kun disse ændringer",
  "Keep other assignments.": "Behold øvrige tildelinger.",
  "Match new selections": "Match de nye valg",
  "Removes other assignments.": "Fjerner øvrige tildelinger.",
  "How do these differ?": "Hvad er forskellen?",
  "Update queued": "Opdatering i kø",
  "Updating existing content": "Opdaterer eksisterende indhold",
  "Update complete": "Opdatering fuldført",
  "Update failed": "Opdatering mislykkedes",
  "You can close this dialog and return later.": "Du kan lukke dialogen og vende tilbage senere.",
  "updated": "opdateret",
  "unchanged": "uændret",
  "No changes were saved.": "Ingen ændringer blev gemt.",
  "View details": "Vis detaljer",
  "Applied networks:": "Anvendte netværk:",
  "Applied tags:": "Anvendte tags:",
  "Close": "Luk",
  "Tags": "Tags",
  "Networks": "Netværk",
  "Replace existing assignments": "Erstat eksisterende tildelinger",
  "Make existing content match the new selections for changed tags or networks. Manual and unrelated assignments will be removed.": "Lad eksisterende indhold matche de nye valg for ændrede tags eller netværk. Manuelle og øvrige tildelinger fjernes.",
  "Changed dimensions:": "Ændrede områder:",
  "Final tags:": "Endelige tags:",
  "Final networks:": "Endelige netværk:",
  "Only changed dimensions will be replaced. Unchanged tags or networks will be preserved.": "Kun ændrede områder erstattes. Uændrede tags eller netværk bevares.",
  "Manual and unrelated assignments in the changed dimensions will be removed. Empty selections clear those assignments. This cannot be undone.": "Manuelle og øvrige tildelinger i de ændrede områder fjernes. Tomme valg rydder disse tildelinger. Dette kan ikke fortrydes.",
  "Replace existing assignments?": "Erstat eksisterende tildelinger?",
  "Replace assignments": "Erstat tildelinger",
  "Loading current source settings...": "Indlæser aktuelle kildeindstillinger...",
  "Source settings could not be loaded. Retry before editing.": "Kildeindstillingerne kunne ikke indlæses. Prøv igen før redigering.",
  "Retry loading": "Prøv at indlæse igen",
  "Previous tags:": "Tidligere tags:",
  "Pending tags:": "Afventende tags:",
  "Apply tag and network changes to existing {{ count }} content item": "Anvend tag- og netværksændringer på {{ count }} eksisterende indholdselement",
  "Apply tag and network changes to existing {{ count }} content items": "Anvend tag- og netværksændringer på {{ count }} eksisterende indholdselementer",
  "Apply only tag and network additions or removals made in this update. Other assignments stay unchanged. Differences from older updates are not repaired. This cannot be undone.": "Anvend kun tags og netværk, der er tilføjet eller fjernet i denne opdatering. Andre tildelinger forbliver uændrede. Forskelle fra tidligere opdateringer rettes ikke. Dette kan ikke fortrydes.",
  // Magic Login Page
  "Sign in to SociuuHub": "Log ind på SociuuHub",
  "To make life easy we've skipped lengthy and difficult passwords. Enter your email and check your inbox for an email with a login link.": "Indsæt din email adresse og modtag en email med adganglink til din personlige Content Hub.",
  "Email Address": "Email Adresse",
  "Email is required.": "Email er påkrævet.",
  "Invalid Email": "Ugylding email.",
  "Send magic link": "Send adgangslink",
  "Welcome to your<br/>Content Hub": "Velkommen til din</br>Content Hub",
  "This is your personal Content Hub, where you will find our latest news, social media posts, and job listings that you can share with your network.": "Dette er din personlige Content Hub, hvor du finder vores seneste nyheder, opslag fra sociale medier og jobopslag du kan dele med dit netværk.",
  "To make life easy we’ve skipped lengthy and difficult passwords. Sign in with your Microsoft account, or enter your email to receive a login link.": "For at gøre livet lettere har vi sprunget lange og vanskelige adgangskoder over. Log ind med din Microsoft-konto, eller indtast din e-mailadresse for at modtage et loginlink.",
  "To make life easy we’ve skipped lengthy and difficult passwords. Simply sign in with your Microsoft account to access your SociuuHub.": "For at gøre livet nemt har vi sprunget lange og vanskelige adgangskoder over. Du skal blot logge ind med din Microsoft-konto for at få adgang til din SociuuHub.",

  // Magic Verify Page
  "Verifying user!": "Verifying user!",

  // Signup Page
  "Signup": "",
  "Signin": "",
  "Sign In": "",
  "Already have an account?": "",
  "First name": "",
  "Last name": "",
  "Email address": "",
  "Phone": "",
  "Department": "",
  "Department is required": "",
  "I agree to the": "",
  "Welcome to": "",
  "Create your account": "",
  "Invalid phone number": "",
  "Allowed domains i.e;": "",
  "Email address or Phone number is required": "",
  "Invalid domain": "",
  "Please enter a valid email address": "",
  "Last name is required": "",
  "Whitespaces are not allowed": "",
  "First name is required": "",

  // Content Hub
  "No contents match your current filters.": "Der er intet indhold, der matcher dine aktuelle filtre.",
  "No contents were found.": "Der blev ikke fundet noget indhold.",
  "Reset filters or adjust your search to see available content.": "Nulstil filtre, eller juster din søgning for at se tilgængeligt indhold.",
  "Reset filters": "Nulstil filtre",
  "Apply network changes to existing {{ count }} content item": "Anvend netværksændringer på {{ count }} eksisterende indholdselement",
  "Apply network changes to existing {{ count }} content items": "Anvend netværksændringer på {{ count }} eksisterende indholdselementer",
  "Apply this update": "Anvend denne opdatering",
  "Apply only the network additions or removals made in this update. Other content-level assignments remain unchanged.": "Anvend kun de netværk, der er tilføjet eller fjernet i denne opdatering. Andre tildelinger på indholdet forbliver uændrede.",
  "Source update:": "Kildeopdatering:",
  "Refresh runs in the background. Sources with an ongoing source update will refresh after that update finishes. Other sources refresh normally. You can close this dialog and continue working.": "Opdateringen kører i baggrunden. Kilder med en igangværende kildeopdatering henter indhold, når den er færdig. Andre kilder opdateres normalt. Du kan lukke denne dialog og arbejde videre.",
  "We are refreshing your Content Hub.": "Vi opdaterer din Content Hub.",
  "This source is being updated. Try again after the update finishes.": "Denne kilde opdateres. Prøv igen, når opdateringen er færdig.",
  "Previous networks:": "Tidligere netværk:",
  "Pending networks:": "Afventende netværk:",
  "Eligible existing content:": "Kvalificeret eksisterende indhold:",
  "Changed existing content:": "Ændret eksisterende indhold:",
  "Queued": "I kø",
  "Processing": "Behandles",
  "Completed": "Fuldført",
  "Failed": "Mislykkedes",
  "None": "Ingen",
  "Apply tag changes separately before applying network changes to existing content.": "Anvend tagændringer separat, før du anvender netværksændringer på eksisterende indhold.",
  "Choose how to apply these tag and network changes to existing content.": "Vælg, hvordan tag- og netværksændringerne skal anvendes på eksisterende indhold.",
  "Source update queued. You can close this dialog and return later.": "Kildeopdateringen er sat i kø. Du kan lukke dialogen og vende tilbage senere.",
  "The source update could not be queued.": "Kildeopdateringen kunne ikke sættes i kø.",
  "The source update could not be prepared. Close the source and try again.": "Kildeopdateringen kunne ikke forberedes. Luk kilden, og prøv igen.",
  "The confirmation could not be shown, so nothing was changed. Please try again.": "Bekræftelsen kunne ikke vises, så intet blev ændret. Prøv igen.",
  'Retry saved update':
    'Prøv den gemte opdatering igen',
  'Retry the saved settings, not unsaved edits in this form.':
    'Prøv igen med de gemte indstillinger, ikke ugemte ændringer i denne formular.',
  'The saved source update could not be retried.':
    'Den gemte kildeopdatering kunne ikke forsøges igen.',
  'The source changed after this operation failed. Reopen the source before retrying.':
    'Kilden blev ændret, efter at denne handling mislykkedes. Åbn kilden igen, før du prøver igen.',
  "Source updated. {{ count }} existing content item changed.": "Kilden er opdateret. {{ count }} eksisterende indholdselement blev ændret.",
  "Source updated. {{ count }} existing content items changed.": "Kilden er opdateret. {{ count }} eksisterende indholdselementer blev ændret.",
  "The source update failed. No changes were saved.": "Kildeopdateringen mislykkedes. Ingen ændringer blev gemt.",
  "Operation failed. Reopen the source and try again.": "Handlingen mislykkedes. Åbn kilden igen, og prøv på ny.",
  "The completed source settings could not be refreshed. Close and reopen the source before editing.": "De opdaterede kildeindstillinger kunne ikke genindlæses. Luk og åbn kilden igen, før du redigerer.",

  // Welcome modal
  "Hi {{ userName }}": "Hi {{ userName }}",
  "Welcome to our social media hub. Take part in sharing all our great stories, news, job posts and more.": "I denne Content Hub finder du vores seneste nyheder, opslag fra sociale medier, ledige jobs og meget mere. Det hele er klar til at blive delt..",
  "Every share counts.": "Alle delinger tæller.",
  "Get started right here": "Gå på opdagelse her",

  // PDF preview
  "This PDF could not be previewed. Please check that the file is valid and try again.": "Denne PDF kunne ikke forhåndsvises. Kontrollér, at filen er gyldig, og prøv igen.",
  "Password-protected PDFs cannot be previewed. Please upload an unprotected PDF.": "Adgangskodebeskyttede PDF-filer kan ikke forhåndsvises. Upload en ubeskyttet PDF.",
  "This PDF preview could not be loaded. Please try again.": "Denne PDF-forhåndsvisning kunne ikke indlæses. Prøv igen.",
  "This PDF could not be previewed. Please try another PDF.": "Denne PDF kunne ikke forhåndsvises. Prøv en anden PDF.",
  "Please wait for the PDF preview to finish loading": "Vent, mens PDF-forhåndsvisningen indlæses",

  // Image uploads
  "Image type is not valid": "Billedtypen er ugyldig",
  "GIF images for LinkedIn must be smaller than 5 MB": "GIF-billeder til LinkedIn skal være mindre end 5 MB",
  "LinkedIn image file size exceeds 50 MB limit": "LinkedIn-billedets filstørrelse overskrider grænsen på 50 MB",
  "Image dimensions is not valid": "Billedets dimensioner er ugyldige",
  "Error processing image file": "Der opstod en fejl under behandlingen af billedfilen",
  "Error reading image file": "Der opstod en fejl under læsningen af billedfilen",

  // Auto-flow / Content Selection
  "Sender identity": "Afsenderidentitet",
  "Sender name": "Afsendernavn",
  "Write the name recipients should see as the email sender.": "Skriv det navn, som modtagerne skal se som e-mailens afsender.",
  "AutoFlow default sender": "AutoFlows standardafsender",
  "Maximum 100 characters.": "Maks. 100 tegn.",
  "From:": "Fra:",
  "Cancel": "Annuller",
  "Save": "Gem",
  "Sender name saved.": "Afsendernavnet er gemt.",
  "Support chat is temporarily unavailable. Please try again later.": "Supportchatten er midlertidigt utilgængelig. Prøv igen senere.",
  'Needs an image for {{ networks }}': 'Kræver et billede til {{ networks }}',
  'and': 'og',
  'Used when this is shared to {{ networks }}.': 'Bruges, når dette deles på {{ networks }}.',
  'On {{ origin }} the original {{ origin }} post is reshared, so these changes don\'t show there.':
    'På {{ origin }} deles det oprindelige {{ origin }}-opslag igen, så disse ændringer vises ikke der.',
  'This video is shared only on {{ origin }}, where the original {{ origin }} post is reshared, so these changes don\'t show there.':
    'Denne video deles kun på {{ origin }}, hvor det oprindelige {{ origin }}-opslag deles igen, så disse ændringer vises ikke der.',
};
